"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var querystring_1 = __importDefault(require("querystring"));
var querystringToObj = function (qs) {
    if (qs === void 0) { qs = window.location.search; }
    if (qs[0] === '?') {
        qs = qs.substr(1);
    }
    return querystring_1.default.parse(qs);
};
exports.default = querystringToObj;
